
























import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";

import FlowMixin from "@/mixins/flow";
import ActionMixin from "@/mixins/action";

import { createSection } from "@/util/data";

import { CSSProperties, ISection } from "@/index.d";

export default class Flow extends mixins(FlowMixin, ActionMixin) {
  private getStyle(styles: CSSProperties) {
    return { height: styles.height };
  }

  private onDragEnter(e: DragEvent, index: number) {
    e.preventDefault();
    this.dragComponentEnter(index);
  }

  private onDragOver(e: DragEvent) {
    e.preventDefault();
  }

  private onDrop(e: DragEvent, section: ISection) {
    e.preventDefault();
    if (e.dataTransfer) {
      const data = JSON.parse(e.dataTransfer.getData("drag-data"));
      const newSection = createSection("static", "flow", "190px");
      newSection.components = [data];
      this.dragComponentDrop({ oldSection: section, newSection });
    }
  }
}
